import type { ReactNode } from 'react';
import { StepSwitch } from './StepSwitch';

export type StepTravelProps = {
  index: number;
  children: ReactNode;
  className?: string;
  /** Stretch inside a flex sheet body (Configuration initiale fill steps). */
  fill?: boolean;
};

/**
 * Horizontal step paging for setup / tour / onboarding.
 * Thin wrapper over login-style {@link StepSwitch} snapshot physics.
 */
export function StepTravel({ index, children, className, fill = false }: StepTravelProps) {
  return (
    <StepSwitch index={index} mode="snapshot" fill={fill} className={className}>
      {children}
    </StepSwitch>
  );
}
